module.exports = {
	"code": "fr",
	"name": "Français",
	"accounting": {
		"currency": {
			"decimal": ",",
			"format": "%v %s",
			"thousand": " "
		},
		"number": {
			"decimal": ",",
			"thousand": " "
		}
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/language.json5
// module id = 1989
// module chunks = 6